import TreeBuilder from "../usersSelector/builder/TreeBuilder";
import CustomerTreeNode from "../hierarchySelector/tree/CustomerTreeNode";
import ProjectTreeNode from "../hierarchySelector/tree/ProjectTreeNode";
import ArchivedCustomersParentTreeNode from "../hierarchySelector/tree/ArchivedCustomersParentTreeNode";
import ArchivedProjectsParentTreeNode from "../hierarchySelector/tree/ArchivedProjectsParentTreeNode";

export default class CPSelectorTreeBuilder extends TreeBuilder {
    constructor(rootNode, projects, customersMap, customersOrder, createEmptyCustomers, observer) {
        super(rootNode, projects, customersMap, customersOrder);
        this.createEmptyCustomers = createEmptyCustomers;
        this.observer = observer;
    }

    createEmptyFirstLevelEntityNodes() {
        return this.createEmptyCustomers;
    }

    createTreeNodeForFirstLevelEntity(customer) {
        return new CustomerTreeNode(customer);
    }

    createTreeNodeForSecondLevelEntity(project) {
        return new ProjectTreeNode(project);
    }

    createDisabledNodesParentForFirstLevelEntity() {
        return new ArchivedCustomersParentTreeNode();
    }

    createDisabledNodesParentForSecondLevelEntity(parentId) {
        return new ArchivedProjectsParentTreeNode(parentId);
    }

    getSecondLevelEntityParentId(project) {
        return project.customerId;
    }

    isFirstLevelEntityEnabled(customer) {
        return !customer.archived;
    }

    isSecondLevelEntityEnabled(project) {
        return !project.archived;
    }

    onTreeNodeForFirstLevelEntityAdded(treeNode) {
        this.observer.customerNodeAdded(treeNode);
    }

    onTreeNodeForSecondLevelEntityAdded(treeNode) {
        this.observer.projectNodeAdded(treeNode);
    }

    onDisabledNodesParentForFirstLevelEntitiesAdded(treeNode) {
        this.observer.archivedCustomersParentNodeAdded(treeNode);
    }

    onDisabledNodesParentForSecondLevelEntitiesAdded(treeNode) {
        this.observer.archivedProjectsParentNodeAdded(treeNode);
    }
}

CPSelectorTreeBuilder.CUSTOMER_NODE_LEVEL = 1;
CPSelectorTreeBuilder.PROJECT_NODE_LEVEL = 2;



// WEBPACK FOOTER //
// ./web/js/cp_selector/CPSelectorTreeBuilder.js